export const DATA_ATTRIBUTES = {
  METADATA: 'data-replit-metadata',
  COMPONENT_NAME: 'data-component-name',
} as const;

export const R3F_IMPORT_SOURCES = new Set([
  '@react-three/fiber',
  '@react-three/drei',
  'react-three-fiber',
]);

// Elements that, if present, indicate the file is likely an R3F scene
export const R3F_BAILOUT_ELEMENTS = new Set([
  'Canvas', // Top-level R3F component
  'mesh',
  'group',
  'scene',
  'primitive',
  'points',
  'instancedMesh',
  'fog',
  'fogExp2',
  'object3D',
]);

// Regex patterns for elements that indicate R3F (e.g. <boxGeometry>, <ambientLight>)
export const R3F_BAILOUT_PATTERNS = [
  /Geometry$/,
  /Material$/,
  /Light$/,
  /Camera$/,
  /Helper$/,
  /Control$/,
];
